require('core-js');require('regenerator-runtime/runtime');// FOUNDATION
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
require('../../retail/shared/foundation/index');

// BASE
require('../../retail/shared/base/index');

// FEATURE
require('./feature/component-blog.js');
require('./feature/component-blog-categories.js');
require('./feature/component-blog-list.js');
require('./feature/component-blog-related.js');
require('./feature/center-regions-spot.js');
require('./feature/component-center-list-spot.js');
require('./feature/component-center-locator.js');
require('./feature/component-center-spot.js');
require('./feature/component-centre-spot/component-centre-spot.js');
require('./feature/component-color-selector-spot.js');
require('./feature/component-comments.js');
require('./feature/component-content.js');
require('./feature/component-cookies.js');
require('./feature/component-data-hierarchy.js');
require('./feature/component-data-hierarchy-lexicon.js');
require('./feature/component-event-calendar.js');
require('./feature/component-form.js');
require('./feature/component-iframe.js');
require('./feature/component-image-spot.js');
require('./feature/component-intro-banner.js');
require('./feature/language-selector-spot.js');
require('./feature/component-lattice-spot.js');
require('./feature/component-news-list-spot.js');
require('./feature/component-online-booking.js');
require('./feature/redirect-notification-spot.js');
require('./feature/component-screening-test.js');
require('./feature/component-search.js');
require('./feature/component-testimonial-spot.js');
require('./feature/component-text-image-spot.js');
require('./feature/component-video-spot.js');
require('./feature/component-two-section-grid.js');

// PROJECT
// require("./custom-footer.js");
require('./project/header.js');
require('./project/main.js');
require('@demant/wdh-gdpr/lib/default.implementation.js');